




<template  >
  <v-dialog  scrollable   width="850" v-model="$store.state.msg.dialogModal">
  <v-card  >
    <v-toolbar style="padding:0px" color="white"  flat  height="60">
      <v-toolbar-title style="margin-left:-30px">
      <v-list two-line  dense  style="padding:0px">

           <v-list-tile>
             <v-list-tile-avatar>
               <img :src="this.$store.state.msg.displayDataMsg.users[msg.selectedReceptor.receptorId].photo_50" alt="ошибка">
             </v-list-tile-avatar>

             <v-list-tile-content>
               <v-list-tile-title  >
                 <a target="_blank" style="text-decoration:none;" :href="'https://vk.com/id'+msg.selectedReceptor.receptorId">
                 <span>{{this.$store.state.msg.displayDataMsg.users[msg.selectedReceptor.receptorId].first_name}} </span>
                 <span>{{this.$store.state.msg.displayDataMsg.users[msg.selectedReceptor.receptorId].last_name}}</span>
                 </a>
               </v-list-tile-title>

               <v-list-tile-sub-title  >
        <!--  {{chat.profiles[0].online_info.last_seen | dateFormatFull}}  -->

               </v-list-tile-sub-title>
             </v-list-tile-content>
           </v-list-tile>

       </v-list>



     </v-toolbar-title>





      <v-spacer></v-spacer>
      <v-icon color="red" @click="deleteChat(msg.selectedReceptor.id)">mdi-delete</v-icon>
      <v-icon color="red" @click="closeChat()">mdi-close</v-icon>
    </v-toolbar>
<v-divider style="color:#273C51" ></v-divider>
  <v-card-text  class="chat">
  <v-layout wrap>


<v-flex md7>

<div v-for="item in chat.items">
<v-card flat>
  <v-card-text>
    <v-layout wrap >
    <v-flex  md12>
<v-avatar  style="margin-right:5px" size="25"><img :src="$store.state.msg.displayDataMsg.users[item.from_id].photo_50" alt="ошибка"></v-avatar>
    <a style="text-decoration:none; " target="_blank" :href="'https://vk.com/id'+item.from_id"> {{$store.state.msg.displayDataMsg.users[item.from_id].first_name }} {{$store.state.msg.displayDataMsg.users[item.from_id].last_name}}</a>
    <span style="color:gray;margin-left:5px">{{item.date|dateFormat}}</span>
    </v-flex>


<v-flex md8 style="margin-left:35px">
<span v-if="item.out && (chat.conversations[0].in_read - chat.conversations[0].out_read)>0" style="background-color:gray; padding:5px;color:white">{{item.text}} </span>
<span v-if="item.out && (chat.conversations[0].in_read - chat.conversations[0].out_read)<=0">{{item.text}} </span>



<span v-if="!item.out">{{item.text}}</span>

</v-flex>

    </v-layout>

  </v-card-text>

</v-card>
</div>




</v-flex>

<v-flex md5  >

</v-flex>


</v-layout>
<div class="bottom"> </div>
</v-card-text>




<v-card-actions
style="background-color:#273C51;"
 >
  <v-text-field
  solo
  @keyup.enter="sendMsg()"
  label="Новое сообщение"
  v-model="newMsg"
  >
  <v-avatar slot="prepend-inner" style="margin-right:5px" size="25"><img :src="$store.state.msg.displayDataMsg.users[msg.selectedReceptor.senderId].photo_50" alt="ошибка"></v-avatar>
  <v-icon  @click="sendMsg()" slot="append">mdi-send</v-icon>
  </v-text-field>

</v-card-actions>




  </v-card>

</v-dialog>
</template>

<script>

import axios from 'axios'

export default {

props:['msg','inits'],
  data () {
    return {
      getterChat: 0,
      stickyOffset: {
        top:300,

      },
newMsg : "",


    }
  },

methods:{
goToDown(){
   this.$vuetify.goTo(".bottom",{ container: ".chat" })
},
closeChat(){
  this.$store.state.msg.dialogModal = false
  if(this.$store.state.msg.page == 1){
    this.inits.offset = 0
  } else {
    this.inits.offset = this.$store.state.msg.page * this.inits.limit - this.inits.limit
  }
  this.$store.dispatch('getMsgWithParams',{init:this.inits})
},
deleteChat(id){
  this.$store.dispatch('deleteChat',{id})
  this.closeChat()
},
sendMsg(){
   let sms = this.newMsg
   this.getChat(sms)
   this.newMsg = ""
   this.goToDown()
  },
getChat(sms){
 this.$store.dispatch('getChat', {selectedReceptor:this.msg.selectedReceptor,sms:sms})
},

},
created(){
  if(this.$store.state.msg.page == 1){
    this.inits.offset = 0
  } else {
    this.inits.offset = this.$store.state.msg.page * this.inits.limit - this.inits.limit
  }
this.$store.dispatch('getMsgWithParams',{init:this.inits})
this.$store.state.msg.selectedDialogData.items = []
this.getChat('')

},

computed:{
  chat(){
    return this.$store.state.msg.selectedDialogData
  },

},

filters:{

  dateFormat(item){
    var months = ['Янв.','Фев.','Мар.','Апр.','Мая','Июнь.','Июль.','Авг.','Сен.','Окт.','Ноя.','Дек.'];

    let d =  new Date(item * 1000)
    // return  d.getDate()+" "+months[d.getMonth()]+"  "+ d.getHours() +":"+ d.getMinutes()
    let mins
    if(d.getMinutes()> 9){
      mins = d.getMinutes()
    } else {
      mins = "0"+ d.getMinutes()
    }
    return  d.getHours() +":"+ mins
  },
  dateFormatFull(item){
    var months = ['Янв.','Фев.','Мар.','Апр.','Мая','Июнь.','Июль.','Авг.','Сен.','Окт.','Ноя.','Дек.'];

    let d =  new Date(item * 1000)
    let mins
    if(d.getMinutes()> 9){
      mins = d.getMinutes()
    } else {
      mins = "0"+ d.getMinutes()
    }
    return  d.getDate()+" "+months[d.getMonth()]+"  "+ d.getHours() +":" + mins

  }
},
}
</script>

<style   >

</style>
